/**
 * @fileoverview This file defines the `finishDiff` function, which uses AI to complete a code diff based on the current git changes and an optional prompt. It leverages `getDiff` to retrieve the diff and `generateCodeWithStreamV2` to generate the code changes using a specified `Model`. Optionally, it can stage the changes using the `add` function.
 */

import { getDiff } from 'git-diff-clean'
import { Model } from '@iterator/shared-node/ai/llm_types'
import { debug, debug_block } from '@iterator/shared-node/util/logging'
import { add } from '@iterator/shared-node/util/git'
import { generateCodeWithStreamV2 } from './generate/generate_v2'

export async function finishDiff(
  directory: string,
  model: Model,
  prompt?: string,
  addChanges: boolean = false,
): Promise<void> {
  debug('finishDiff', { directory, model, prompt, addChanges })

  if (addChanges) {
    await add(directory)
  }

  const diffString = getDiff({
    includePlusMinus: true,
    includeColors: false,
    includeEmoji: false,
    includeFooter: false,
    includeUntracked: addChanges,
    cached: !addChanges,
  })
  debug_block('Diff String', diffString)

  await generateCodeWithStreamV2(
    directory,
    `Please finish the following code diff.${prompt ? `\n\n<guidance>\n${prompt}\n</guidance>` : ''}\n\n<diff>\n${diffString}\n</diff>`,
    model,
    'documentation',
  )
}
